
import {css} from "lit"
export default css`@layer view {

button {
	background: transparent;
	border: none;
	font-size: inherit;
}

button {
	opacity: var(--inactive-opacity);
	display: flex;
	align-items: center;

	cursor: copy;
	color: inherit;
	transition: all var(--anim-duration) linear;

	&:is(:hover, :focus-visible) {
		opacity: 1;
	}

	> span {
		display: flex;
	}
}

[data-status="invalid"] {
	color: var(--lame);
}

[data-status="good"] {
	opacity: 1;
	color: var(--happy);
	filter: drop-shadow(0 0 0.3em color-mix(in oklab, transparent, currentColor 50%));
}

[data-status="bad"] {
	opacity: 1;
	color: var(--angry);
	filter: drop-shadow(0 0 0.3em color-mix(in oklab, transparent, currentColor 50%));
}

svg {
	width: 1em;
	height: 1em;
}

}`

